module.exports = __webpack_public_path__ + "img/20.5735c9e9.png";